import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Transition } from '../../../../../workflow/types';
import { WorkflowStateManager } from '../../../../../workflow/workflow-state-manager';

@Component({
    selector: 'mcb-transition-bar',
    templateUrl: './transition-bar.component.html',
})
export class TransitionBarComponent {
    @Input() transitions: Transition[];
    @Output() returnClick = new EventEmitter<any>();
    @Output() transitionClick = new EventEmitter<Transition>();

    constructor(public stateManager: WorkflowStateManager) {
    }

    isTransitionDisabled(t: Transition) {
        return !this.stateManager.transitionsEnabled || !t.enabled;
    }
}
